/**
 * public/ 정적 자산·절대 경로를 배포 base 경로에 맞춰 만든다.
 *
 * 앱은 루트(`/`) 또는 프리픽스(`VITE_BASE=/001/` → https://pro.salphadtx.com/001/) 로 배포될 수 있다.
 * 라우터 이동(navigate/Link)은 basename 이 붙어 있어 그대로 쓰면 되지만, `<img src>`·`window.open`·`location.replace`
 * 처럼 브라우저가 직접 해석하는 절대 경로는 이 함수로 감싼다. 루트 배포에서는 입력 그대로 돌려준다.
 */
const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

export const publicUrl = (absolutePath: string): string =>
  `${BASE}${absolutePath.startsWith("/") ? absolutePath : `/${absolutePath}`}`;
